import { patchCustomPanel, selectPreset, } from './utils';
export function recurrencePanelReducer(state, action) {
    switch (action.type) {
        case 'HYDRATE':
            return action.panel;
        case 'SET_PRESET':
            return selectPreset(state, action.value, action.dateStart, action.abtUntilDate);
        case 'PATCH_CUSTOM':
            return patchCustomPanel(state, action.patch);
        default: {
            var _exhaustiveCheck = action;
            return _exhaustiveCheck;
        }
    }
}
export function shouldBumpConversionId(prev, next) {
    return (next.presetUnderAbt !== null ||
        (prev.recurrenceRule !== 'CUSTOM' && next.recurrenceRule === 'CUSTOM') ||
        prev.selectedWeekdays !== next.selectedWeekdays);
}
